import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useForm from 'react-hook-form';
import PropTypes from 'prop-types';
/* actions */
import {
  editNetworksGroup,
  getAllNetworksGroup
} from '../../redux/actions/networksGroup';
import { getAllDepartments } from '../../redux/actions/departments';
import { getAllDevices } from '../../redux/actions/devices';
import ErrorMsgField from '../../components/ErrorMsgField';
/* components */
import AlertMsg from '../../components/AlertMsg';
import FormFooter from '../../components/FormFooter';
import FormHeader from '../../components/FormHeader';
import MultiSelect from '../../components/MultiSelect';
/* form-validation */
import schema from '../../form-validation/networksGroup';
/* utils */
import sortable from '../../utils/sortable';
import {
  handleMultiSelect,
  handleMultiDeselect
} from '../../utils/multiSelect';
import handleChangeDefault from '../../utils/handleChangeDefault';

function Edit (props) {
  const { id } = props.match.params;
  const INITIAL_VALUES = {
    name: '',
    department: '',
    description: '',
    devices: []
  };
  const dispatch = useDispatch();
  const submitButton = useRef();
  const { register, handleSubmit, errors } = useForm({
    validationSchema: schema,
    reValidateMode: 'onSubmit'
  });
  const departments = useSelector(state => state.departments);
  const devices = useSelector(state => state.devices.data);
  const networksGroup = useSelector(state => state.networksGroup);
  const networkGroup = networksGroup.data.find(
    networkGroup => networkGroup._id === id
  );
  const [selectedOptions, setSelectedOptions] = useState({ devices: [] });
  const [networks, setNetworks] = useState([]);
  const [data, setData] = useState(INITIAL_VALUES);

  useEffect(() => {
    dispatch(getAllDepartments());
    dispatch(getAllDevices());
  }, [dispatch]);

  useEffect(() => {
    if (devices.length) {
      const networks = devices
        .filter(device => device.type === 'N')
        .map(device => ({
          value: device._id,
          text: `N${device.number}`,
          sortValue: `N${device.number}`
        }))
        .sort(sortable);
      setNetworks([...networks]);
    }
  }, [devices, setNetworks]);

  useEffect(() => {
    if (!networkGroup) {
      dispatch(getAllNetworksGroup());
    }
  }, [dispatch, networkGroup]);

  useEffect(() => {
    if (networkGroup) {
      const newData = {
        ...networkGroup,
        department: networkGroup.department._id || ''
      };
      setData(newData);
    }
  }, [networkGroup]);

  useEffect(() => {
    if (networkGroup) {
      const devices = networks.filter(network =>
        networkGroup.devices.includes(network.value)
      );
      setSelectedOptions({ devices });
    }
  }, [networkGroup, networks, setSelectedOptions]);

  const submit = () => {
    dispatch(editNetworksGroup(data, submitButton.current));
  };

  return (
    <div className="container-fluid">
      {networksGroup.editSuccess && (
        <AlertMsg type="success" msg="Grupo de tronco atualizado com sucesso" />
      )}
      {networksGroup.errorContent &&
        !networksGroup.errorContent.message.includes('400') &&
        networksGroup.editError && (
        <AlertMsg
          type="danger"
          msg="Falha durante atualização do grupo de tronco"
        />
      )}
      {networksGroup.errorContent &&
        networksGroup.errorContent.message.includes('400') &&
        networksGroup.editError && (
        <AlertMsg
          type="danger"
          msg="Um grupo com o nome informado já está cadastrado"
        />
      )}
      {!networksGroup.editSuccess && !networksGroup.editError && (
        <AlertMsg type="info" msg="Área atualização do grupo de tronco" />
      )}
      <FormHeader title="Atualizar Grupo de Tronco" />
      <form id="form" onSubmit={handleSubmit(submit)}>
        <div className="form-group">
          <label htmlFor="name">
            Nome<span className="field-required">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            name="name"
            autoComplete="off"
            value={data.name}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          />
          {errors.name && errors.name.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
          {errors.name && errors.name.type === 'max' && (
            <ErrorMsgField type="max" />
          )}
          {errors.name && errors.name.type === 'min' && (
            <ErrorMsgField type="min" />
          )}
        </div>
        <div className="form-group">
          <label htmlFor="department">
            Departamento<span className="field-required">*</span>
          </label>
          <select
            className="form-control"
            id="department"
            name="department"
            value={data.department}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          >
            <option value="">-- Selecione --</option>
            {departments.data.map((dpt, i) => {
              const _id = dpt._id || Date.now() + '' + i;
              return (
                <option key={_id} value={_id}>
                  {dpt.name}
                </option>
              );
            })}
          </select>
          {errors.department && errors.department.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <div className="form-group">
          <label htmlFor="description">
            Descrição<span className="field-required">*</span>
          </label>
          <textarea
            className="form-control"
            id="description"
            name="description"
            rows="3"
            value={data.description}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          ></textarea>
          {errors.description && errors.description.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <MultiSelect
          avaliableOptions={networks}
          selectedOptions={selectedOptions.devices}
          handleMultiDeselect={options =>
            handleMultiDeselect(
              options,
              'devices',
              selectedOptions,
              setSelectedOptions,
              data,
              setData
            )
          }
          handleMultiSelect={options =>
            handleMultiSelect(
              options,
              'devices',
              selectedOptions,
              setSelectedOptions,
              data,
              setData
            )
          }
          valueProp="value"
          textProp="text"
          title="Troncos"
          fieldRequired={true}
          name="devices"
          ref={register}
          error={!!errors.devices}
        />
        <FormFooter url="/networks_group" reference={submitButton} />
      </form>
    </div>
  );
}

Edit.propTypes = {
  match: PropTypes.object
};

export default Edit;
